"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = function _default(editorState, phrases, shouldSkip) {
  var contentState = editorState.getCurrentContent();
  var blockMap = contentState.getBlockMap();
  var skip = false;
  return blockMap.reduce(function (phrase, contentBlock) {
    var blockKey = contentBlock.getKey();
    var blockText = contentBlock.getText().toLowerCase();

    if (phrase !== null) {
      return phrase;
    }

    if (skip || shouldSkip(contentBlock, contentState)) {
      skip = true;
      return null;
    }

    return phrases.reduce(function (includedPhrase, _phrase) {
      if (includedPhrase !== null) {
        return includedPhrase;
      }

      var regex = new RegExp("\\b" + _phrase + ".*?\\b");
      var result = regex.exec(blockText);

      if (result !== null) {
        var text = result[0];
        var offset = result.index;
        return (0, _immutable.Map)({
          offset: offset,
          blockKey: blockKey,
          phrase: text
        });
      }

      return null;
    }, null);
  }, null);
};

exports.default = _default;
module.exports = exports.default;